import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesAutoSafe,
} from '../../../../../St/Reports/UseStyle';
import { get } from "@awesome-cordova-plugins/core/decorators/common";
import { invoicePayTypes } from "../../../../../services/invoice-service";
import { sto } from "../../../../../Context/InshData";
export default function TransfersSearchForm(props) {
    const {
        rptParams,
        onChangeData,
        isEstelam,
        changTField,
        AutoOptions,
        onChangeAutoData,
        allSafes,
        SafesEmp,
        branches,
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();


    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}
            className="notranslate">
            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={ sto.User_typei == 1?branches: AutoOptions?.Branches}
                        disabled={ sto.User_typei == 1?false:true}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="bill_no"
                        label={t("order-no")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="text"
                        name="no" value={rptParams.bill_no} onChange={onChangeData('no')}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        label={t("ref-no")}
                        placeholder={t("ref-no")}

                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="text"
                        name="refno" value={rptParams.refno} onChange={onChangeData('refno')}
                    />
                </Grid>
                {isEstelam && (
                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="refno"
                            label={t("transfer-order-no")}
                            placeholder={t("transfer-order-no")}

                            className={clasTF.rootSafe}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            type="text"
                            name="transfer_no" value={rptParams.transfer_no} onChange={onChangeData('transfer_no')}
                        />
                    </Grid>
                )}
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateFrom" label={t("date-from")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParams.dateFrom} onChange={onChangeData('dateFrom')}
                    /></Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateTo" label={t("date-to")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParams.dateTo} onChange={onChangeData('dateTo')}
                    /></Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasASafe}
                        value={rptParams.safeFrom}
                        onChange={(event, newValue) => {
                            onChangeAutoData("safeFrom", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={sto.User_typei == 1 ? allSafes : isEstelam ? AutoOptions?.Safes :SafesEmp}
                        getOptionLabel={(option) =>
                            typeof option === "string"
                                ? option
                                : option?.name?.toString()
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("safe-from")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrSafe }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasASafe}
                        value={rptParams.safeTo}
                        onChange={(event, newValue) => {
                            onChangeAutoData("safeTo", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={sto.User_typei == 1 ? allSafes : isEstelam ?SafesEmp: AutoOptions?.Safes}
                        getOptionLabel={(option) =>
                            typeof option === "string"
                                ? option
                                : option?.name?.toString()
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("safe-to")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrSafe }}
                            />
                        )}
                    />

                </Grid>

            </Grid>
        </React.Fragment>
    );
}
